import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function SortDownNormal({ size, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M5.33398 6.68244L7.99442 9.43634L10.6673 6.6665"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function SortUpNormal({ size, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M5.33398 9.31756L7.99442 6.56366L10.6673 9.3335"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function SortDownOrange({ size, stroke = '#FF6633', ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M5.33398 6.68244L7.99442 9.43634L10.6673 6.6665"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function SortUpOrange({ size, stroke = '#FF6633', ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M5.33398 9.31756L7.99442 6.56366L10.6673 9.3335"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function SortUpDown({ size, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="17"
      fill="none"
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M5.83325 9.24933L8.49368 12.0032L11.1666 9.2334"
        stroke="#BEBEC7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M5.83325 6.75393L8.49368 4.00003L11.1666 6.76987"
        stroke="#BEBEC7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function DragNDrop({ size, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M7.24023 3.5C7.24023 4.32843 6.56866 5 5.74023 5C4.91181 5 4.24023 4.32843 4.24023 3.5C4.24023 2.67157 4.91181 2 5.74023 2C6.56866 2 7.24023 2.67157 7.24023 3.5Z"
        fill="#5F616E"
      />
      <path
        d="M7.24023 8C7.24023 8.82843 6.56866 9.5 5.74023 9.5C4.91181 9.5 4.24023 8.82843 4.24023 8C4.24023 7.17157 4.91181 6.5 5.74023 6.5C6.56866 6.5 7.24023 7.17157 7.24023 8Z"
        fill="#5F616E"
      />
      <path
        d="M7.24023 12.5C7.24023 13.3284 6.56866 14 5.74023 14C4.91181 14 4.24023 13.3284 4.24023 12.5C4.24023 11.6716 4.91181 11 5.74023 11C6.56866 11 7.24023 11.6716 7.24023 12.5Z"
        fill="#5F616E"
      />
      <path
        d="M11.7402 3.5C11.7402 4.32843 11.0687 5 10.2402 5C9.41181 5 8.74023 4.32843 8.74023 3.5C8.74023 2.67157 9.41181 2 10.2402 2C11.0687 2 11.7402 2.67157 11.7402 3.5Z"
        fill="#5F616E"
      />
      <path
        d="M11.7402 8C11.7402 8.82843 11.0687 9.5 10.2402 9.5C9.41181 9.5 8.74023 8.82843 8.74023 8C8.74023 7.17157 9.41181 6.5 10.2402 6.5C11.0687 6.5 11.7402 7.17157 11.7402 8Z"
        fill="#5F616E"
      />
      <path
        d="M11.7402 12.5C11.7402 13.3284 11.0687 14 10.2402 14C9.41181 14 8.74023 13.3284 8.74023 12.5C8.74023 11.6716 9.41181 11 10.2402 11C11.0687 11 11.7402 11.6716 11.7402 12.5Z"
        fill="#5F616E"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

SortDownNormal.propTypes = iconPropTypes
SortUpNormal.propTypes = iconPropTypes
SortDownOrange.propTypes = iconPropTypes
SortUpOrange.propTypes = iconPropTypes
SortUpDown.propTypes = iconPropTypes
DragNDrop.propTypes = iconPropTypes

const iconsTable = {
  SortDownNormal,
  SortUpNormal,
  SortDownOrange,
  SortUpOrange,
  SortUpDown,
  DragNDrop
}

export default iconsTable
